import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import DownloadIcon from "@redotech/redo-icons/download-01.svg";
import { toast } from "@redotech/redo-web/alert";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo, useState } from "react";
import { RedoOutboundLabelsRpcClientContext } from "../../outbound-labels-rpc-client";

export const ParcelPackingSlipDownloadButton = memo(
  function ParcelPackingSlipDownloadButton({
    fulfillmentGroupId,
    parcelIndex,
  }: {
    fulfillmentGroupId: string;
    parcelIndex: number;
  }) {
    const [pending, setPending] = useState(false);
    const rpcClient = useRequiredContext(RedoOutboundLabelsRpcClientContext);

    const handleDownload = useHandler(async (e: React.MouseEvent) => {
      e.stopPropagation();
      setPending(true);
      try {
        const { url } = await rpcClient.getParcelPackingSlip({
          fulfillmentGroupId,
          parcelIndex,
        });
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `parcel-packing-slip-${parcelIndex + 1}.pdf`;
        document.body.append(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(blobUrl);
      } catch {
        toast("Failed to download package packing slip", { variant: "error" });
      } finally {
        setPending(false);
      }
    });

    return (
      <RedoButton
        hierarchy="tertiary"
        IconLeading={DownloadIcon}
        onClick={handleDownload}
        pending={pending}
        size="sm"
        text="Packing slip"
      />
    );
  },
);
